import React from 'react';
import { Route, Routes, Link } from 'react-router-dom'
import {Layout, Typography, Space} from 'antd';
import {Navbar,Homepage,Exchanges,Cryptocurrencies,CryptoDetails,News, Footer} from './components';
import './App.css';

const App = () => {
    return (
        <div className="app">
            <div className="navbar">
              <Navbar />
            </div>
            <div className="main">

                    <Layout>
                    <Routes>
                        <Route exact path="/" element={<Homepage/>}/>
                        <Route exact path="/exchanges" element={<Exchanges/>}/>
                        <Route exact path="/cryptocurrencies" element={<Cryptocurrencies/>}/>
                        <Route exact path="/crypto/:coinId" element={<CryptoDetails/>}/>
                        <Route exact path="/news" element={<News/>}/>



                       
                   </Routes>
                        

                    </Layout>
              <br/>
              <Footer />
            </div>
        </div>
    )
}


export default App;
